import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
/* ===========================
IMPORTS
=========================== */
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

/* ===========================
RENDER
=========================== */
const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
registerServiceWorker();
